import { ZodType } from 'zod'
import { z } from 'zod'

import {
  TripPlaceToCenterRequest,
  TripPlaceToCenterRequestPartial
} from '../../../lib/types/models/trip-place-to-center-request/trip-place-to-center-request'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { AllocatedPlaceFormInput } from './trip-date-booking-to-center-form'

export const tripDateBookingToCenterFormSchema = (
  tripPlaceToCenterRequests?: TripPlaceToCenterRequest[] | TripPlaceToCenterRequestPartial[]
): ZodType<AllocatedPlaceFormInput> =>
  z
    .object({
      data: z.array(
        z.object({
          allocatedPlaceId: createNumberSchema('id'),
          numberOfStudentsPlacesAllocated: createNumberSchema('# jeunes', { nonNegative: true }),
          numberOfStaffPlacesAllocated: createNumberSchema('# encadrants', { nonNegative: true })
        })
      )
    })
    .superRefine(({ data }, ctx) => {
      if (!tripPlaceToCenterRequests)
        throw Error('tripPlaceToCenterRequests is required and cannot be undefined')

      for (const {
        allocatedPlaces,
        numberOfStaffPlacesRequested,
        numberOfStudentsPlacesRequested
      } of tripPlaceToCenterRequests) {
        const allocatedPlacesInput = data.filter((item) =>
          allocatedPlaces.map((a) => a.id).includes(item.allocatedPlaceId)
        )
        // The summation of the number of staff and student spots allocated should be lessthanequal to the number of staff and student spots of the tripPlaceToCenterRequest
        const numberOfStaffPlacesAllocated = allocatedPlacesInput.reduce(
          (acc, curr) => acc + curr.numberOfStaffPlacesAllocated,
          0
        )
        const numberOfStudentsPlacesAllocated = allocatedPlacesInput.reduce(
          (acc, curr) => acc + curr.numberOfStudentsPlacesAllocated,
          0
        )
        if (
          numberOfStaffPlacesRequested &&
          numberOfStaffPlacesAllocated > numberOfStaffPlacesRequested
        ) {
          for (const allocatedPlaceInput of allocatedPlacesInput) {
            const index = data.findIndex(
              (item) => item.allocatedPlaceId === allocatedPlaceInput.allocatedPlaceId
            )
            if (allocatedPlaceInput.numberOfStaffPlacesAllocated > 0)
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Nombre de places encadrants réparties > demandées',
                path: [`data[${index}].numberOfStaffPlacesAllocated`]
              })
          }
        }

        if (numberOfStudentsPlacesAllocated > numberOfStudentsPlacesRequested) {
          for (const allocatedPlaceInput of allocatedPlacesInput) {
            const index = data.findIndex(
              (item) => item.allocatedPlaceId === allocatedPlaceInput.allocatedPlaceId
            )
            if (allocatedPlaceInput.numberOfStudentsPlacesAllocated > 0)
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                // The number of allocated student spots is greater than the number of reserved student spots
                message: 'Nombre de places jeunes réparties > demandées',
                path: [`data[${index}].numberOfStudentsPlacesAllocated`]
              })
          }
        }
      }
    })
